import { LuEdit } from "react-icons/lu";
import { MenuItem } from "@chakra-ui/react";
import { MenuList } from "@chakra-ui/react";
import { LuTrash } from "react-icons/lu";
import { ColumnActionsProps } from "./types";

const ColumnActions = ({ onEdit, onDelete }: ColumnActionsProps) => {
  return (
    <MenuList>
      {onEdit && <MenuItem onClick={(e) => {
        e.stopPropagation();
        onEdit();
      }}
        icon={<LuEdit />}
      >
        Edit
      </MenuItem>}
      {onDelete && <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        color="red.500"
        icon={<LuTrash />}
      >
        Delete
      </MenuItem>
      }
    </MenuList>
  );
};

export default ColumnActions;